import { Pipe, PipeTransform } from '@angular/core';
import { Field, SourceTable } from '../target-column.models';

@Pipe({
  name: 'columnType',
})
export class ColumnTypePipe implements PipeTransform {
  transform(column: string, sourceTable?: SourceTable | null): string {
    if (sourceTable?.fields) {
      return (
        sourceTable.fields.find((f: Field) => f.field_name.toLowerCase() === column.toLowerCase())?.data_type || ''
      );
    }

    return '';
  }
}
